module.exports = __webpack_public_path__ + "static/img/wxtp_20260714114137_92_157.3307261.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/news/20260714/wxtp_20260714114137_92_157.jpg
// module id = z0Yl
// module chunks = 0